import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";
import { getConsent } from "./mockAuth";

/**
 * Helper analytics Library (Sesi L9, pola reportStore).
 * - Consent analytics dibaca lokal: tanpa consent, tidak ada panggilan callable.
 * - Server memvalidasi ulang consent + allowlist + strip param non-teks.
 * - Kegagalan logging tidak pernah mengganggu alur baca (gagal diam).
 */
export async function logLibraryEvent(event, params = {}) {
  try {
    const consent = typeof getConsent === "function" ? getConsent() : null;
    if (!consent || consent.analytics !== true) return { dropped: true };
    const fn = httpsCallable(functions, "logLibraryEvent");
    const res = await fn({ event, params });
    if (res.data?.ok) return { dropped: Boolean(res.data.dropped), eventId: res.data.eventId ?? null };
    return { dropped: true };
  } catch {
    return { dropped: true };
  }
}
